"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const inertia_react_1 = require("@inertiajs/inertia-react");
const react_1 = __importDefault(require("react"));
const react_helmet_async_1 = require("react-helmet-async");
const ziggy_js_1 = __importDefault(require("ziggy-js"));
const pages = [
    { route: "ansade-login", name: "Login" },
    { route: "register", name: "Register" },
];
const Layout = ({ title, children }) => {
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_helmet_async_1.Helmet, { titleTemplate: "%s | Dataportal Ansade", title: title }),
        react_1.default.createElement("header", { className: "top-0 z-50 h-20 bg-white shadow flex w-full max-w-[100vw] items-center justify-between py-0 px-8 xl:px-[5%]" },
            react_1.default.createElement("div", { className: "relative h-12 w-48" },
                react_1.default.createElement(inertia_react_1.InertiaLink, { href: "/" },
                    react_1.default.createElement("img", { src: "/pictures/logo-ansade.png", alt: "Ansade", className: "absolute left-0 h-full" }))),
            react_1.default.createElement("a", { href: "/register" }, "S'inscrire"),
            react_1.default.createElement(inertia_react_1.Link, { href: "/logout", method: "post" }, "Se d\u00E9connecter")),
        react_1.default.createElement("main", { className: "flex w-full h-[calc(100vh-5rem)] " },
            react_1.default.createElement("aside", { className: "flex w-1/5 h-full flex-col bg-[#004e81]" },
                react_1.default.createElement("ul", { className: "mt-12 text-[#5eccff] text-lg " },
                    react_1.default.createElement("li", { className: "py-2 pl-10" },
                        react_1.default.createElement(inertia_react_1.InertiaLink, { className: "hover:text-white", href: (0, ziggy_js_1.default)("images.index") }, "Images")),
                    react_1.default.createElement("li", { className: "py-2 pl-10" },
                        react_1.default.createElement(inertia_react_1.InertiaLink, { className: "hover:text-white", href: (0, ziggy_js_1.default)("datasets.index") }, "Datasets")),
                    react_1.default.createElement("li", { className: "py-2 pl-10" },
                        react_1.default.createElement(inertia_react_1.InertiaLink, { className: "hover:text-white", href: (0, ziggy_js_1.default)("homepagedata.index") }, "Homepage Data")))),
            react_1.default.createElement("section", { className: "w-4/5" },
                react_1.default.createElement("div", { className: "w-full px-4 py-8 overflow-hidden overflow-y-auto md:p-12" }, children)))));
};
exports.default = Layout;
